import { AfterViewInit, Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CredencialesService } from 'src/app/shared/services/credenciales.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { UsuariosService } from 'src/app/shared/services/usuarios.service';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { RUT } from 'src/app/shared/utils/rut';
import { gtpRutValidator } from 'src/app/shared/validators/rut-validator';

export interface InputModel {
  credencial: string[],
  tipoCredencial: string,
  rut?: string;
  validCred?: string;
  dateStatus?: string;
}

@Component({
  selector: 'app-mat-modal-credenciales',
  templateUrl: './mat-modal-credenciales.component.html',
  styleUrls: ['./mat-modal-credenciales.component.scss']
})
export class MatModalCredencialesComponent implements AfterViewInit {
  inputModel: InputModel | any = {
    credencial: [],
    tipoCredencial: '',
    rut: '',
    validCred: '',
    dateStatus: ''
  };
  
  public showSpinner: boolean = false;
  public messages: { text: string, isError: boolean, isSuccess: boolean }[] = [];

  public dataCredencial: any = {}; // INFORMACION CREDENCIALES (RUT)
  public servicio: any = {}; // INFORMACION SERVICIO

  public showForm: boolean = false;
  public configurarForm!: UntypedFormGroup;
  public passControl: any = {};

  public booleanValueOptions: {displayName: string, value: any}[] = [
    {displayName: "Seleccione una opción", value: ""}, 
    {displayName: "Si", value: true}, 
    {displayName: "No", value: false},
  ];

  public ultimosDatos: {name: string, value: any}[] = [];
  public credValidada: boolean | string = '';
  public iconMensaje: string = '';

  constructor(public dialogRef: MatDialogRef<MatModalCredencialesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InputModel, 
      private formBuilder: UntypedFormBuilder,
      private credencialesService: CredencialesService,
      private _sessionService: SessionService,
      private usuariosService: UsuariosService,
      private utilsService: UtilsService
    ) {
      this.inputModel = data;
      if(this.inputModel?.tipoCredencial == 'CRED.ORG' || this.inputModel?.tipoCredencial == 'ORG') {
        this.flujoOrg();
      } else if (this.inputModel?.tipoCredencial == 'RUT') {
        this.flujoRut();
      } else {
        console.error('Tipo de credencial no identificada')
        this.close();
      }
  }

  ngAfterViewInit(): void {
  }

  formatRut(rut: string) {
    rut = rut.replace(/\./g, ''); // Quitar puntos
    
    if (!rut.includes('-')) {
      // Agregar guion antes del último dígito si no tiene guion.
      rut = rut.slice(0, -1) + '-' + rut.slice(-1);
    }
    
    return rut;
  }

  flujoOrg(): void {
    this.showSpinner = true;
    this.credencialesService.listarSecretosOrgyUsuarios().subscribe(
      (data: any) => {
        this.showSpinner = false;
        const listaOrganizacion = data?.OrgConfiguration || {};
        let servicios = listaOrganizacion?.services?.services || [];

        if((servicios.length > 0)){
          servicios = servicios.filter((element: any) => element?.display?.indexOf("organizacion") > -1);
          this.validateServicios(servicios);
        } else {
          this.obtenerContratoServicios();
        }
      },
      ({ error }) => {
        this.showSpinner = false;
        this.showErrorAndClose(error.message || 'Ha ocurrido un error al obtener el listado.', 'Ha ocurrido un error al obtener el listado.');
    });
  }

  obtenerContratoServicios(): void {
    this.showSpinner = true;
    this.credencialesService.obtenerContrato().subscribe(
      (data: any) => {
        this.showSpinner = false;
        let servicios = data?.services || [];
        if((servicios.length > 0)){
          servicios = servicios.filter((element: any) => element?.display?.indexOf("organizacion") > -1);
          this.validateServicios(servicios);
        } else {
          this.showErrorAndClose('Se ha obtenido una lista vacia en el contrato', 'Listado de servicios vacio.');
        }
      },
      ({ error }) => {
        this.showSpinner = false;
        this.showErrorAndClose(error.message || 'Ha ocurrido un error al obtener el listado del contrato.', 'Ha ocurrido un error al obtener el listado del contrato.');
    });
  }

  validateServicios(servicios: any[]): void {
    if(!servicios || servicios.length <= 1) {
      this.showErrorAndClose('Se ha obtenido una lista vacia en el contrato', 'Listado de servicios vacio.')
    }

    const servicioEncontrado = servicios.find((e: any) => e.name == this.inputModel?.credencial?.[0]);
    if(servicioEncontrado) {
      this.servicio = servicioEncontrado;

      if(this.servicio?.attributes.find((e: any) => e.typeFormat === 'RUT')) {
        this.llamadaGetRut();
      } else {
        this.initForm();
      }
    } else {
      this.showErrorAndClose('No se ha encontrado el servicio a configurar.', 'Servicio no encontrado en listado');
    }

  }

  llamadaGetRut(): void {
    this.showSpinner = true;
    this.usuariosService.getOrganizationDetails().subscribe(
      (data) => {
        this.showSpinner = false;
        if(data?.rut) {
          this.inputModel.rut = data?.rut || '';
          this.initForm();
        } else {
          this.showErrorAndClose('Ha ocurrido un error al validar los datos de la organización.', 'No se encontro el rut del usuario')
        }
      },
      ({ error }) => {
        this.showSpinner = false;
        this.showErrorAndClose(error.message || 'Ha ocurrido un error al obtener los datos de la organización', 'Ha ocurrido un error al obtener los datos de la organización');
      }
    );
  }

  flujoRut(): void {
    if(!this.inputModel?.rut) {
      this.showErrorAndClose('Ha ocurrido un error inesperado.', 'No se encontro en rut como entrada');
      return;
    }

    const rut = this.formatRut(this.inputModel?.rut);
    this.showSpinner = true;
    this.credencialesService.listarSecretosOrgyUsuarios(undefined, undefined, rut).subscribe(
      (data: any) => {
        this.showSpinner = false;
        const listaUsuario = this.agregaDisplayRutReturn(data?.UserList || []);
        const rutEncontrado = listaUsuario.find(e => e.displayRut === rut)
        if(rutEncontrado){
          this.dataCredencial = rutEncontrado;
          this.getServiceSelected();
        } else {
          this.llamadaApiObtenerContratoUsuario(rut);
        }
      },
      ({ error }) => {
        this.showSpinner = false;
        this.showErrorAndClose(error.message || 'Ha ocurrido un error al buscar la información el rut indicado.', 'Ha ocurrido un error al buscar la información el rut indicado.');
    });
  }

  llamadaApiObtenerContratoUsuario(rut: string): void{
    this.showSpinner = true;
    const rut1 = rut.split('-')[0];
    const dv = rut.split('-')[1];
    this.credencialesService.obtenerContrato().subscribe(
      (data: any) => {
        this.showSpinner = false;
        if(data?.services.length > 0){
          this.dataCredencial = {
            "idOrganizacion": this._sessionService.getOrganization(),
            "rut": rut1,
            "displayRut": rut,
            "dv": dv,
            "services": data || {}
          }

          if(this.dataCredencial?.services && Object.keys(this.dataCredencial?.services).length > 0){
            this.dataCredencial.services.idUsuario = this._sessionService.getUserInfo().username;
            this.dataCredencial.services.idOrganizacion = this._sessionService.getOrganization();
            this.dataCredencial.services.rut = rut1;
            this.dataCredencial.services.requestOrigin = "WEB";
          }

          this.getServiceSelected();

        } else {
          this.showErrorAndClose('Se ha obtenido una lista vacia en el contrato', 'Listado de servicios vacio.');
        }
      },
      ({ error }) => {
        this.showSpinner = false;
        this.showErrorAndClose(error.message || 'Ha ocurrido un error al obtener el listado.', 'Ha ocurrido un error al obtener el listado.');
    });
  }

  getServiceSelected(): void {
    const servicios = this.dataCredencial?.services?.services;
    if(servicios && servicios.length > 0) {
      const servicioEncontrado = servicios.find((e: any) => e.name == this.inputModel?.credencial?.[0] && e?.display?.indexOf("usuarios") > -1)
      if(servicioEncontrado) {
        this.servicio = servicioEncontrado;

        if(this.servicio?.attributes.find((e: any) => e.typeFormat === 'RUT')) {
          if(this.inputModel?.rut) {
            this.initForm();
          } else {
            this.showErrorAndClose('No se encontró el rut para consultar.', 'Rut no encontrado como entrada');
            return;
          }
        } else {
          this.initForm();
        }
      } else {
        this.showErrorAndClose('No se ha encontrado el servicio a configurar.', 'Servicio no encontrado en listado');
      }
    } else {
      this.showErrorAndClose('Se ha obtenido una lista vacia en el contrato.', 'No se detecto datos en el contrato');
    }
  }

  initForm(): void {
    this.generarUltimosDatos();

    this.configurarForm = this.formBuilder.group({});
    const atributos: any[] = this.servicio?.attributes || [];
    const rut = this.formatRut(this.inputModel?.rut);

    for(const [index, atributo] of atributos.entries()){
      if(atributo?.display === true) {
        const validatorsArray: any[] = [Validators.required];
        if(atributo.typeFormat === 'RUT'){
          validatorsArray.push(gtpRutValidator());
          atributo.value = rut;
          this.configurarForm.addControl(atributo?.name, new UntypedFormControl({value: rut, disabled: true}, validatorsArray));
        } else {
          this.configurarForm.addControl(atributo?.name, new UntypedFormControl(
            typeof(atributo?.value) == 'boolean' ? atributo?.value : (atributo?.value || '')
            , validatorsArray));
        }

        if(atributo?.typeFormat === 'PASSWORD') {
          this.passControl[atributo?.name] = true;
        }
      }
    }
  
    this.showForm = true;    
  }

  agregaDisplayRutReturn(listaUsuario: any[]): any[] {
    listaUsuario.forEach((element: any) => {
      element.displayRut = (element.rut + "-" + element.dv) || '';
    });
    return listaUsuario;
  }

  showErrorAndClose(message: string, msgLog: string): void {
    this.addMessage(message, true, false);
    console.error(msgLog);
    setTimeout(()=> {
      this.close();
    }, 3000);
  }

  close() {
    this.dialogRef.close(false);
  }

  addMessage(mensaje: string, isError: boolean, isSuccess: boolean) : void {
    this.messages.push({ text: mensaje, isError: isError, isSuccess: isSuccess });
  }

  removeMessage(index: number) {
    this.messages.splice(index, 1);
  }

  typeTraduccion(type: string): string {
    switch(type){
      case 'STRING':
        return 'text';
      case 'BOOLEAN':
        return 'boolean';
      case 'PASSWORD':
        return 'password';
      case 'RUT':
        return 'text';
      case 'DATE':
        return 'date';
      case 'NUMBER':
        return 'number';
      default:
        return 'text';
    }
  }

  showIcon(): boolean {
    if(this.servicio?.onlineValidationCreds != true) return false;
    if(this.credValidada !== true && this.credValidada !== false) return false;
    if(!this.servicio?.requestValidationCreds || Object.keys(this.servicio?.requestValidationCreds).length <= 0) return false;
    if(!this.ultimosDatos || this.ultimosDatos.length <= 0) return false;

    const todosCumplen = this.ultimosDatos.every(element => {
      const name = this.servicio?.requestValidationCreds[element.name];
      const valueForm = this.configurarForm.get(name)?.value;
      return element.value === valueForm;
    });

    if(todosCumplen) return true;

    return false;
  }

  validacionBtnGuardar(): boolean {
    if(this.servicio?.onlineValidationCreds == false || 
      (this.servicio?.onlineValidationCreds == true && this.showIcon() && this.credValidada == true)
    )
      return true;
    return false;
  }

  soloNumerosLetrasString(str: string): string {
    return str.replace(/[^a-zA-Z0-9]/g, '');
  }

  generarUltimosDatos(): void {
    if(this.servicio?.onlineValidationCreds === true && this.servicio?.requestValidationCreds && Object.keys(this.servicio?.requestValidationCreds).length > 0){
      
      if(!this.servicio?.attributes && !(this.servicio?.attributes.length >= 0) ){
        return
      }
      const requestValidationCreds = this.servicio?.requestValidationCreds;
      const atributos: any[] = this.servicio?.attributes || [];

      for(const [key, value] of Object.entries(requestValidationCreds)){
        const atributo = atributos.find(e => e.name === value);
        if(atributo){
          this.ultimosDatos.push({name: key, value: atributo?.value});
        }
      }

    }
  }

  actualizaUtimosDatos(request: any): void {
    if(request && Object.keys(request).length > 0){
      for(const [key, value] of Object.entries(request)){
        const ultimoDato = this.ultimosDatos.find(e => e.name === key);
        if(ultimoDato){
          ultimoDato.value = value;
        }
      }
    }
  }

  validaCredenciales(): void {
    if(!this.servicio?.onlineValidationCreds) {
      this.addMessage('No se logra configuración para validar.', true, false);
      return;
    }

    if(this.showIcon() && this.credValidada == false) {
      this.addMessage('Debe actualizar los valores ingresados para validar.', true, false);
      return;
    }

    if(this.ultimosDatos.length === 0){
      this.addMessage('No se logra conseguir los campos para validar.', true, false);
      return;
    }

    if(!this.servicio?.requestValidationCreds && !(Object.keys(this.servicio?.requestValidationCreds).length > 0)){
      this.addMessage('No se logra conseguir los campos para validar.', true, false);
      return;
    }

    if (!this.configurarForm.valid) {
      this.utilsService.validateAllFormFields(this.configurarForm);
      this.addMessage('Complete los campos para crear/actualizar el servicio.', true, false);
      return;
    }

    const request: any = {};
    const formTemp: any = this.configurarForm.getRawValue();

    // validacion que los ruts sean el mismo del usuario seleccionado
    for(const [key, value] of Object.entries(this.servicio?.requestValidationCreds)){
      const element = this.servicio?.attributes?.find((e: any) => e.name === value);
      if(value && element?.typeFormat === 'RUT' && formTemp?.[value as string]){

        let rutEntrada = '';
        if(this.inputModel?.tipoCredencial == 'CRED.ORG' || this.inputModel?.tipoCredencial == 'ORG') {
          if(!this.inputModel?.rut) {
            this.showErrorAndClose('No se encontró el rut para consultar.', 'Rut no encontrado como entrada')
          }
          rutEntrada = this.inputModel?.rut.toUpperCase();
        } else if (this.inputModel?.tipoCredencial == 'RUT') {
          if(!this.dataCredencial?.displayRut) {
            this.showErrorAndClose('No se encontró el rut para consultar.', 'Rut no encontrado como entrada')
          }
          rutEntrada = this.dataCredencial?.displayRut.toUpperCase();
        } else {
          console.error('Tipo de credencial no identificada');
          this.showErrorAndClose('Tipo de credencial no identificada', 'Tipo de credencial no identificada')
        }

        let rut = this.soloNumerosLetrasString(formTemp?.[value as string]).toUpperCase();
        rut = RUT.applyBackendFormat(rut);
        rutEntrada = RUT.applyBackendFormat(this.soloNumerosLetrasString(rutEntrada));
        if(rut !== rutEntrada) {
          this.addMessage('El rut del formulario no coincide con el rut esperado.', true, false);
          return;
        }
      }
    }

    for(const [key, value] of Object.entries(this.servicio?.requestValidationCreds)){
      request[key] = "";
      if(value && formTemp?.[value as string]) {
        request[key] = formTemp?.[value as string];
      }
    }

    let validacionRequest = true;
    for(const [key, value] of Object.entries(request)){
      if(value === '' || value === null || value === undefined){
        validacionRequest = false;
      }
    }

    if(!validacionRequest){
      this.addMessage("Ocurrio un error al obtener los valores del formulario.", true, false);
      return;
    }

    this.actualizaUtimosDatos(request);

    for(const [key, value] of Object.entries(request)){
      const keyValue = this.servicio?.requestValidationCreds[key];
      if(keyValue) {
        const element = this.servicio?.attributes?.find((e: any) => e.name === keyValue);
        if(element?.typeFormat === 'RUT' && value) {
          const rut = this.soloNumerosLetrasString(value as string);
          request[key] = RUT.applyBackendFormat(rut);
        } else if (element.typeFormat === 'BOOLEAN') {
          request[key] = value == 'true' ? true : (value == 'false' ? false : value);
        }
      } 
    }
    
    const service = this.servicio?.name;
    
    this.showSpinner = true;
    this.credValidada = '';
    this.credencialesService.validarCredencialesDinamico(request, service).subscribe(
      (data: any) => {
        this.credValidada = true;
        this.iconMensaje = data?.message || 'Se han validado correctamente las credenciales.';
        this.showSpinner = false;
      },
      ({ error }) => {
        const mensaje: string = error.message ? error.message : error && typeof(error) == 'string' ? error : 'Ha ocurrido un error al consultar la validacion de credenciales.'; 
        this.credValidada = false;
        this.iconMensaje = mensaje;
        this.addMessage(mensaje, true, false);
        this.showSpinner = false;
    });        

  }

  onSubmit(): void {
    if (!this.configurarForm.valid) {
      this.utilsService.validateAllFormFields(this.configurarForm);
      this.addMessage('Complete los campos para crear/actualizar el servicio.', true, false);
      return;
    }

    const formTemp = this.configurarForm.getRawValue();

    let rutEntrada = '';
    if(this.inputModel?.tipoCredencial == 'CRED.ORG' || this.inputModel?.tipoCredencial == 'ORG') {
      rutEntrada = this.inputModel?.rut.toUpperCase();
    } else if (this.inputModel?.tipoCredencial == 'RUT') {
      rutEntrada = this.dataCredencial?.displayRut.toUpperCase();
    }
    rutEntrada = RUT.applyBackendFormat(this.soloNumerosLetrasString(rutEntrada));

    for(const atributo of this.servicio?.attributes) {
      if(atributo?.typeFormat === 'RUT') {

        if(!rutEntrada) {
          this.showErrorAndClose('No se encontró el rut para consultar.', 'Rut no encontrado como entrada')
        }

        let rut = this.soloNumerosLetrasString(formTemp?.[atributo.name]).toUpperCase();
        rut = RUT.applyBackendFormat(rut);

        if(rut !== rutEntrada) {
          this.addMessage('El rut del formulario no coincide con el rut esperado.', true, false);
          return;
        }

      }

    }

    const request = JSON.parse(JSON.stringify(this.servicio))
    if(request){
      delete request.configurationStatus;
      delete request.displayName;
    }

    request?.attributes?.forEach((element: any) => {
      if (element?.display === true) {
        const formValue = formTemp?.[element.name];
        
        if (formValue !== undefined && formValue !== null) {
          if (element.typeFormat === 'RUT') {
            element.value = RUT.applyBackendFormat(this.soloNumerosLetrasString(formValue));
          } else if (element.typeFormat === 'BOOLEAN') {
            element.value = formValue == 'true' ? true : (formValue == 'false' ? false : formValue);
          } else {
            element.value = formValue;
          }
        }
      }
    });

    this.showSpinner = true;
    this.credencialesService.crearActualizarCredenciales(
      this.inputModel?.tipoCredencial == 'RUT' ? rutEntrada : "", 
      [request]
    ).subscribe(
      (data: any) => {
        this.addMessage(data.message || 'Se ha creado/actualizado correctamente el servicio.', false, true);
        this.dialogRef.close(true); // indicador de que se actualizo un secreto al que llama al modal
      },
      ({ error }) => {
        this.addMessage(error.message || 'Ha ocurrido un error al consultar crear/actualizar servicio.', true, false);
        this.showSpinner = false;
    });

  }

}
